import React from 'react';
import { Box, Paper, Skeleton, Stack } from '@mui/material';

function Shimmer(props: React.ComponentProps<typeof Skeleton>) {
  return (
    <Skeleton
      animation="wave"
      {...props}
      sx={(t) => ({
        bgcolor: t.tokens?.surface?.sunken ?? 'action.hover',
        ...((typeof props.sx === 'function' ? props.sx(t) : props.sx) as object),
      })}
    />
  );
}

export default function DialOpportunityLoadingSkeleton() {
  return (
    <Box sx={{ width: '100%', minHeight: 'min(720px, calc(100vh - 220px))' }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 2.5 }}>
        {[0, 1, 2].map((i) => (
          <Paper
            key={i}
            elevation={0}
            sx={(t) => ({
              flex: 1,
              p: 2.5,
              minHeight: 132,
              borderRadius: `${t.ds.radius.md}px`,
              border: `1px solid ${t.tokens.border.subtle}`,
            })}
          >
            <Shimmer variant="rounded" width={120} height={14} sx={{ mb: 1.5, borderRadius: 0.5 }} />
            <Shimmer variant="rounded" width={96} height={36} sx={{ mb: 1, borderRadius: 0.75 }} />
            <Shimmer variant="rounded" width="70%" height={14} sx={{ borderRadius: 0.5 }} />
          </Paper>
        ))}
      </Stack>

      <Paper
        elevation={0}
        sx={(t) => ({
          p: 2.5,
          mb: 2.5,
          minHeight: 140,
          borderRadius: `${t.ds.radius.md}px`,
          border: `1px solid ${t.tokens.border.subtle}`,
        })}
      >
        <Shimmer variant="rounded" width={88} height={18} sx={{ mb: 1.5, borderRadius: 0.75 }} />
        <Shimmer variant="rounded" width="98%" height={14} sx={{ mb: 0.75, borderRadius: 0.5 }} />
        <Shimmer variant="rounded" width="94%" height={14} sx={{ mb: 0.75, borderRadius: 0.5 }} />
        <Shimmer variant="rounded" width="86%" height={14} sx={{ borderRadius: 0.5 }} />
      </Paper>

      <Paper
        elevation={0}
        sx={(t) => ({
          overflow: 'hidden',
          borderRadius: `${t.ds.radius.md}px`,
          border: `1px solid ${t.tokens.border.subtle}`,
        })}
      >
        <Box sx={{ px: 2.5, py: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Shimmer variant="rounded" width={240} height={22} sx={{ borderRadius: 0.75 }} />
        </Box>
        <Stack spacing={1.25} sx={{ p: 2.5 }}>
          {Array.from({ length: 8 }).map((_, idx) => (
            <Shimmer key={idx} variant="rounded" width="100%" height={16} sx={{ borderRadius: 0.5 }} />
          ))}
        </Stack>
      </Paper>
    </Box>
  );
}
